'use client';

import Link, { type LinkProps } from 'next/link';
import React from 'react';
import { useI18n } from '@/shared/providers/I18nProvider';
import { isValidLocale } from '@/shared/config/locales';

type Props = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> &
  LinkProps & {
    href: string;
    locale?: string;
  };

function withLocalePrefix(path: string, locale: string): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  const parts = normalized.split('/');
  const maybeLocale = parts[1];
  if (maybeLocale && isValidLocale(maybeLocale)) return normalized;
  return `/${locale}${normalized}`;
}

export function LocaleLink({ href, locale, ...props }: Props) {
  const { lang } = useI18n();
  const effectiveLocale = locale ?? lang;
  return <Link href={withLocalePrefix(href, effectiveLocale)} {...props} />;
}

